import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    TransactionhistoryRes: [],
    createpaymentres: [],

    checkWithdrawStatusRes: [],

    paymenthistory: [],
    error: "",
}

const transactionSlice = createSlice({
    name: 'transaction',
    initialState,
    reducers: {
        userTransactionhistory: (state, action) => {
            state.TransactionhistoryRes = action.payload
        },

        userPayment: (state, action) => {
            state.createpaymentres = action.payload
        },
        getPaymenthis: (state, action) => {
            state.paymenthistory = action.payload
        },
        getWithdrawStatus: (state, action) => {
            state.checkWithdrawStatusRes = action.payload
        }
    }
})

export const { userTransactionhistory, userPayment, getPaymenthis, getWithdrawStatus } = transactionSlice.actions;
export default transactionSlice.reducer;



export const getTransactionhistory = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.GET_DEPOSIT_WITHDRAW_HISTORY}`, data);
            callback(response);
            dispatch(userTransactionhistory(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };


export const getcreatepayment = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.CREATE_PAYMENT}`, data);
            callback(response);
            dispatch(userPayment(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };

export const getpaymenthistory = (data, callback = () => { }) =>

    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.GET_PAYMENT}`, data);

            callback(response);
            dispatch(getPaymenthis(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };
export const checkWithdrawStatus = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.CHECK_WITHTRAW_MAXIMUM}`, data);
            callback(response);
            dispatch(getWithdrawStatus(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };
